import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { Table, TablePagination } from "components/base";
import { parseBatteryModelTable } from "utils/parsers";
import {
  initializeBatteryModels,
  setIssuesSelectedPage,
} from "store/actions";
import { ActionMenu } from "./cell-renders";
import { TableProps } from "antd/lib/table";
import { Card, List, Typography, Space, Grid } from "antd";
import "styles/components/tab-content/battery-content/battery-model.scss"; 

const { useBreakpoint } = Grid;
const { Text } = Typography; // Removed Title since it's not needed

// Desktop columns
const columns: TableProps<any>["columns"] = [
  {
    title: "Sr",
    dataIndex: "id",
    width: 80,
    ellipsis: true,
    responsive: ["md"],
  },
  {
    title: "Make",
    dataIndex: "make",
    width: 130,
    ellipsis: true,
    responsive: ["sm"],
  },
  {
    title: "Model",
    dataIndex: "model",
    width: 130,
    ellipsis: true,
  },
  {
    title: "Year",
    dataIndex: "year",
    width: 100,
    ellipsis: true,
    responsive: ["sm"],
  },
  {
    title: "",
    dataIndex: "action",
    render: ActionMenu,
    align: "right",
    width: 56,
    className: "action-menu open-link --issues",
  },
];

// Mobile Card Component
interface MobileCardProps {
  item: any;
}

const MobileCard: React.FC<MobileCardProps> = ({ item }) => (
  <Card 
    className="mobile-battery-card"
    size="small"
     title={null} 
    extra={ActionMenu("", item)}
  >
    <Space direction="vertical" size={4} style={{ width: "100%" }}>
      <div className="card-row">
        <Text type="secondary">Sr:</Text>
        <Text strong>{item.id}</Text>
      </div>
      <div className="card-row">
        <Text type="secondary">Make:</Text>
        <Text>{item.make}</Text>
      </div>
      <div className="card-row">
        <Text type="secondary">Model:</Text>
        <Text>{item.model}</Text>
      </div>
      <div className="card-row">
        <Text type="secondary">Year:</Text>
        <Text>{item.year}</Text>
      </div>
    </Space>
  </Card>
);

export default function TableView() {
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  
  const {
    batteryModels,
    page,
    search,
    selectedBatteryModelRows,
    filters: { listType },
  } = useSelector<AppState, AppState["batteryModels"]>(
    (state) => state.batteryModels
  );
  
  const { selectedPage, totalPages } = page;

  const data = useMemo(
    () => parseBatteryModelTable(search, batteryModels, listType),
    [batteryModels, listType, search]
  );

  useEffect(() => {
    dispatch(initializeBatteryModels());
  }, [dispatch]);

  const onChangeSelection = useCallback((value) => {
    console.log("values : ", value);
  }, []);

  const onBack = useCallback(() => {
    if (selectedPage > 1) {
      dispatch(setIssuesSelectedPage(selectedPage - 1));
    }
  }, [dispatch, selectedPage]);

  const onNext = useCallback(() => {
    if (selectedPage < totalPages) {
      dispatch(setIssuesSelectedPage(selectedPage + 1));
    }
  }, [dispatch, selectedPage, totalPages]);

  const resetCallback = useCallback(() => {
    dispatch(setIssuesSelectedPage(1));
  }, [dispatch]);

  const isMobile = !screens.md;

  const getScrollHeight = () => {
    if (screens.xs) return "50vh";
    if (screens.sm) return "60vh";
    return "70vh";
  };

  return (
    <div className="table-view-container">
      {isMobile ? (
        <div className="mobile-list-container">
          <List
            dataSource={data}
            header={null} // Explicitly set header to null
            renderItem={(item: any) => (
              <List.Item style={{ padding: "8px 0", border: "none" }}>
                <MobileCard item={item} />
              </List.Item>
            )}
            locale={{ emptyText: "No battery models found" }}
          />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          // scroll={{ 
          //   x: "max-content",
          //   y: getScrollHeight() 
          // }}
          className="responsive-table"
          size={screens.lg ? "middle" : "small"}
        />
      )}
      {/* <TablePagination
        page={page}
        onBack={onBack}
        onNext={onNext}
        resetCallback={resetCallback}
      /> */}
    </div>
  );
}